import React, { useEffect, useState } from 'react';
import Footer from '../../shared/footer/Footer';
import LoginModal from '../../main/loginModal/LoginModal';
import Head from '../../Global/Head';
import Header from '../../Global/Header';
import { AiOutlineCalendar, AiOutlineShareAlt } from 'react-icons/ai';
import { HiOutlineLocationMarker } from 'react-icons/hi';
import { BsBookmark } from 'react-icons/bs';

export default function Blog5() {
  const accessToken = localStorage.getItem("@user");
  const [isVisible, setIsVisible] = useState(!!accessToken ? false : true);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const increment = 1300 / steps;

    if (isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - increment;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="min-h-screen ">
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <Head />

      <Header />
      <div className="max-w-7xl mx-auto p-6">
        <h1 className="text-4xl font-bold mt-4">Hyper-Independence vs Interdependence: Finding the Balance</h1>
        <div className="mt-4 flex items-start justify-between">
          <div className="flex items-center gap-4 text-sm text-gray-600">
           
            <div className="flex items-center gap-2">
              <span className="inline-block bg-black text-white px-2 py-0.5 rounded">HighTable</span>
            </div>
          </div>
         
        </div>

        <div className="mt-6 rounded-lg overflow-hidden">
          <img
            src="https://res.cloudinary.com/diecfwnp9/image/upload/v1761403960/IMG_0946_uqbotf.jpg"
            alt="Where Women Rise Together"
            className="w-full h-64 sm:h-96 object-cover"
          />
        </div>

    <div className="article-container">
      <section className="intro">
        <p>
          We live in a world that celebrates independence—especially for women.
          “Do it yourself,” “handle it alone,” “be self-sufficient”—these messages
          are everywhere. While independence is empowering, taken to the extreme,
          it can become hyper-independence: a pattern where relying on anyone else
          feels uncomfortable or even threatening. At <strong>Hightable</strong>,
          we believe true strength lies in balancing independence with
          interdependence.
        </p>
      </section>

      <hr />

      <section className="hyper-independence">
        <h2>What Hyper-Independence Looks Like</h2>
        <p>
          Hyper-independent people pride themselves on self-reliance, often
          avoiding asking for help, sharing vulnerabilities, or leaning on others
          emotionally. While it can feel protective, it comes with hidden costs:
        </p>
        <ul>
          <li>Emotional burnout from carrying everything alone</li>
          <li>Shallow connections due to reluctance to open up</li>
          <li>Missed opportunities for collaboration and growth</li>
        </ul>
        <p>
          Being hyper-independent isn’t a flaw—it’s a coping mechanism. But
          unchecked, it can limit personal and professional fulfillment.
        </p>
      </section>

      <hr />

      <section className="interdependence">
        <h2>Why Interdependence Matters</h2>
        <p>
          Interdependence is the art of balancing autonomy with healthy reliance
          on others. It’s about knowing when to take charge and when to let your
          tribe support you. Humans are wired to connect; our best ideas,
          creativity, and resilience often emerge from collaboration.
        </p>
        <p>
          On <strong>Hightable</strong>, interdependence is celebrated. By
          connecting with like-minded individuals, women can:
        </p>
        <ul>
          <li>Share experiences without judgment</li>
          <li>Seek guidance or mentorship</li>
          <li>Celebrate wins and navigate challenges together</li>
          <li>Build a network that empowers personal and professional growth</li>
        </ul>
      </section>

      <hr />

      <section className="balance">
        <h2>Finding the Balance</h2>
        <p>
          Balancing independence and interdependence isn’t about losing control—
          it’s about choosing wisely. Here are some practical steps:
        </p>
        <ol>
          <li>Identify When to Ask for Help: Not every challenge needs to be faced alone.</li>
          <li>Build Trust Gradually: Open up in small ways to test support systems.</li>
          <li>Offer Support, Too: Interdependence is reciprocal; helping others strengthens your connections.</li>
          <li>Celebrate Autonomy: Retain your self-reliance in areas that matter to you.</li>
        </ol>
        <p>
          The balance is dynamic—it shifts depending on context, goals, and
          relationships. The key is awareness and intention.
        </p>
      </section>

      <hr />

      <section className="how-hightable-helps">
        <h2>How Hightable Helps</h2>
        <p>
          <strong>Hightable</strong> provides a space where women can safely
          explore this balance. By facilitating authentic connections, shared
          experiences, and support networks, the platform encourages members to
          rely on each other without losing their sense of independence. It’s not
          just about making friends or networking—it’s about finding your tribe
          while staying true to yourself.
        </p>
      </section>

      <hr />

      <section className="takeaway">
        <h2>The Takeaway</h2>
        <p>
          Hyper-independence can feel empowering, but true growth comes from
          learning when to lean on others. Interdependence allows women to
          flourish, create deeper connections, and thrive without sacrificing
          autonomy. On <strong>Hightable</strong>, we help women strike that
          balance—because strength and support go hand in hand.
        </p>
      </section>
    </div>

      </div>
      <Footer />
    </div>
  );
}
